<ion-content class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-four title="Aviso de Farmacovigilancia"></app-title-four>
  </div>

  <ion-grid class="form-data">
    <ion-row>
      <ion-col size="12">
        <section>
          <br />
          <ion-label class="doc-content">
            <p>¿NECESITA REPORTAR UN EFECTO ADVERSO U OTRA INFORMACIÓN DE SEGURIDAD CON UN MEDICAMENTO DE SANOFI? Contáctenos por las siguientes vías:</p> <br/>
            <ul>
              <li>Argentina y Paraguay: vía correo electrónico a <a href="mailto:Farmacovigilancia.Argentina@sanofi.com">Farmacovigilancia.Argentina@sanofi.com</a> o al número de teléfono: <a href="tel:+541147325000">+54 11 4732-5000</a>.</li>
              <li>Chile: vía correo electrónico a <a href="mailto:Farmacovigilancia.Chile@sanofi.com">Farmacovigilancia.Chile@sanofi.com</a> o al número de teléfono: <a href="tel:+56233408400">+56 2 3340 8400</a>.</li>
            </ul>
          </ion-label>
        </section>
      </ion-col>
      <ion-col size="12" class="center">
        <button (click)="closeModal()" shape="round" class="btn-primary btn-close">Cerrar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
